import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    leaveList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    leaveDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    leaveStat: {
        requesting: false,
        error: null,
        success: false,
        data: {
            pending: 0,
            approved: 0,
            rejected: 0,
            currently_out: 0,
            upcoming_this_week: 0,
            upcomming_this_month: 0,
            total_days: 0,
        }
    },
    leaveApprovedList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    scheduledOutTime: {
        requesting: false,
        success: false,
        error: null,
        data: null,
    },
  };

export const leaveSlice = createSlice({
  name: 'leave',
  initialState,
  reducers: {
    getLeaveList: (state, action) => {
        state.leaveList.requesting = true;
        state.leaveList.error = null;
        state.leaveList.items = [];
        state.leaveList.success = false;
        state.leaveList.filters = action.payload;
    },
    getLeaveListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;   
        state.leaveList.requesting = false;
        state.leaveList.items = data;
        state.leaveList.success = true; 
        state.leaveList.pagination.current_page = current_page;
        state.leaveList.pagination.per_page = per_page;
        state.leaveList.pagination.total = total;
    },
    getLeaveListFail: (state, action) => {        
        state.leaveList.requesting = false;
        state.leaveList.error = action.payload;
    },
    getLeaveDetails: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    getLeaveDetailsSuccess: (state, action) => {
        state.leaveDetails.requesting = false;
        state.leaveDetails.data = action.payload;
        state.leaveDetails.success = true; 
    },
    getLeaveDetailsFail: (state, action) => {        
        state.leaveDetails.requesting = false;
        state.leaveDetails.error = action.payload;
    },
    getLeaveStat: (state, action) => {
        state.leaveStat.requesting = true;
        state.leaveStat.error = null;
        state.leaveStat.data = {};
        state.leaveStat.success = false;
        state.leaveStat.filters = action.payload;
    },
    getLeaveStatSuccess: (state, action) => {
        state.leaveStat.requesting = false;
        state.leaveStat.data = action.payload;
        state.leaveStat.success = true; 
    },
    getLeaveStatFail: (state, action) => {        
        state.leaveStat.requesting = false;
        state.leaveStat.error = action.payload;
    },
    getLeavePendingList: (state, action) => {
        state.leavePendingList.requesting = true;
        state.leavePendingList.error = null;
        state.leavePendingList.data = {};
        state.leavePendingList.success = false;
        state.leavePendingList.filters = action.payload;
    },
    getLeavePendingListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;   
        state.leavePendingList.requesting = false;
        state.leavePendingList.items = data;
        state.leavePendingList.success = true; 
        state.leavePendingList.pagination.current_page = current_page;
        state.leavePendingList.pagination.per_page = per_page;
        state.leavePendingList.pagination.total = total; 
    },
    getLeavePendingListFail: (state, action) => {        
        state.leavePendingList.requesting = false;
        state.leavePendingList.error = action.payload;
    },
    doLeaveCreate: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    doLeaveUpdate: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    doLeaveDelete: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    doLeaveApproval: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    getScheduledOutTime: (state) => {
        state.scheduledOutTime.requesting = true;
        state.scheduledOutTime.error = null;
        state.scheduledOutTime.data = null;
        state.scheduledOutTime.success = false; 
    },
    getScheduledOutTimeSuccess: (state, action) => {
        state.scheduledOutTime.requesting = false;
        state.scheduledOutTime.data = action.payload;
        state.scheduledOutTime.success = true; 
    },
    getScheduledOutTimeFail: (state, action) => {        
        state.scheduledOutTime.requesting = false;
        state.scheduledOutTime.error = action.payload;
    },
  },
})

export const { 
    getLeaveList, getLeaveListSuccess, getLeaveListFail,
    getLeaveDetails, getLeaveDetailsSuccess, getLeaveDetailsFail,
    getLeaveStat, getLeaveStatSuccess, getLeaveStatFail,
    doLeaveCreate, doLeaveUpdate, doLeaveDelete,
    doLeaveApproval,
    getLeavePendingList, getLeavePendingListSuccess, getLeavePendingListFail,
    getScheduledOutTime, getScheduledOutTimeSuccess, getScheduledOutTimeFail
} = leaveSlice.actions

export default leaveSlice.reducer